/**
 * Parse an ISO-8601-ish timestamp, coercing naive strings to UTC.
 *
 * The square-game API frequently returns timestamps without an explicit
 * timezone (e.g. `2025-01-01T12:00:00`). `new Date(s)` on such a string is
 * interpreted as *local* time in some browsers, which drifts hold countdowns
 * and draw times for anyone outside UTC. This helper appends `Z` whenever no
 * zone indicator is present so parsing is always UTC-anchored.
 *
 * @param {string|Date|null|undefined} input
 * @returns {Date|null} parsed Date, or null for invalid/empty input
 */
export function parseUtcIso(input) {
  if (!input) return null;
  if (input instanceof Date) return isNaN(input.getTime()) ? null : input;
  let s = String(input).trim();
  if (!s) return null;
  // Accept 'YYYY-MM-DDTHH:mm:ss[.fff]' (no zone) and coerce to UTC by adding 'Z'.
  // Human-readable strings (e.g. "Friday, June 12, 2026") are NOT UTC-anchored —
  // they come from the API already formatted in org-local time, so appending 'Z'
  // would shift them to the previous day for viewers west of UTC.
  if (/^\d{4}-\d{2}-\d{2}([T ]|$)/.test(s) && !/[zZ]|[+-]\d{2}:?\d{2}$/.test(s)) s = s + 'Z';
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}

export default parseUtcIso;
